import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  error: '',
  checkoutSession: '',
  merchantOrderId: ''
};

export const yunoPaymentSlice = createSlice({
  name: 'yunoPayment',
  initialState: INITIAL_STATE,
  reducers: {
    yunoPaymentSession: (state, action) => {
      if (typeof action.payload === 'string') {
        state.checkoutSession = action.payload;
        state.merchantOrderId = ''; // Ou algum valor padrão
      } else {
        state.checkoutSession = action.payload.checkoutSession;
        state.merchantOrderId = action.payload.merchantOrderId;
      }
    },
    clearYunoPaymentSession: (state) => {
      state.error = '';
      state.checkoutSession = '';
      state.merchantOrderId = '';
    }
  }
});

export const { yunoPaymentSession, clearYunoPaymentSession } = yunoPaymentSlice.actions;

export default yunoPaymentSlice;
